import { render } from "./contact.info.editor.pane.vue?vue&type=template&id=3280f4d8"
import script from "./contact.info.editor.pane.vue?vue&type=script&lang=js"
export * from "./contact.info.editor.pane.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__